export class AlarmRoutes
{
    static Home = "/";
    // Alarm
    static AlarmList: string = `/alarm/list`;
    static AlarmNew: string = `/alarm/new`;
    static AlarmCopy(id: string)
    {
        return `/alarm/${id}/new`;
    }
    static AlarmEdit(id: string)
    {
        return `/alarm/${id}/edit`;
    }
    static AlarmView(id: string)
    {
        return `/alarm/${id}/view`;
    }
}